// extracted by mini-css-extract-plugin
module.exports = {"Manual":"Manual_Manual__2xkCN"};